'use client';
/** @jsxImportSource @emotion/react */

import React, { forwardRef, type ElementType, type Ref } from 'react';

import {
  type OverridableComponent,
  type OverrideProps,
} from '@mui/material/OverridableComponent';
import MuiStack, { type StackTypeMap } from '@mui/material/Stack';

type ExcludedMuiProps = '';
type CustomProps = {
  component?: ElementType;
};

type ZeusStackTypeMap<
  P = CustomProps,
  D extends ElementType = StackTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<StackTypeMap['props'], ExcludedMuiProps> & P;
};

/**
 * @deprecated Please use Tailwind CSS utilities instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-stack-migration--migration Migration guide}
 */
export type StackProps<
  D extends ElementType = StackTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<StackTypeMap<P, D>, D>;

const StackComponent = (props: StackProps, ref: Ref<HTMLDivElement>) => {
  return <MuiStack {...props} ref={ref} />;
};

StackComponent.displayName = 'Stack';

/**
 * @deprecated Please use Tailwind CSS utilities instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-stack-migration--migration Migration guide}
 */
export const Stack = forwardRef(
  StackComponent
) as OverridableComponent<ZeusStackTypeMap>;
